export const STATUSES = {
    RECOMMENDED: 'recommended',
    PENDING: 'pending',
    APPROVED: 'approved',
    DELETED: 'deleted',
};
